(function () {
    'use strict';

    angular
        .module('app')
        .factory('pdfedit_dialog', PdfEditDialog);

    PdfEditDialog.$inject = ['DialogService'];

    /**
     * Display a dialog for the PDF editor.
     * This is an override of the pdfedit_dialog service declared in the pdfEdit module.
     */
    function PdfEditDialog(DialogService) {
        var service = {
            showDialog: showDialog
        };

        PdfEditDialogCtrl.$inject = ['$scope', 'DialogInstance'];

        return service;

        function showDialog(templateHtml, scope) {
            var childScope = scope.$new();

            DialogService.show({
                template:
                    '   <drv-dialog-body close-on-click="closeDialog()">' +
                    templateHtml +
                    '   </drv-dialog-body>' +
                    '   <drv-dialog-footer>' +
                    '       <md-button ng-click="closeDialog()" class="md-primary md-raised main-button">' +
                    '           OK' +
                    '       </md-button>' +
                    '   </drv-dialog-footer>',
                controller: PdfEditDialogCtrl,
                scope: childScope
            });
        }

        function PdfEditDialogCtrl($scope, DialogInstance) {
            $scope.closeDialog = function () {
                DialogInstance.ok();
            };
        }
    }
})();